




import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface Catalog {
  typeCatalog: string;
}

@Component({ components: { SimpleText } })
export default class Type extends Vue {
  @Prop() public catalog !: Catalog;

  public static getNeededFields(): string[] {
      return [
          "catalog.typeCatalog",
      ];
  }
}
